import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import "../styles/components/landing-page.scss"
import CustomButton from './CustomButton';
import { useHistory } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { authenticateUser } from '../features/User/UserSlice';



const LandingPage = () => {
    const history = useHistory()
    const { isAuth } = useSelector((state: RootState) => state.user);
    const dispatch = useDispatch();

    const handleOnClick = () => {
        history.push("/login")
    }

    useEffect(() => {
        dispatch(authenticateUser());

    }, [])

    useEffect(() => {
        if (isAuth) {
            history.push("/home")
        }
    }, [isAuth])

    return (
        <div className="landing-page">
            <header>
                <h1>Habituate Me</h1>
                <p>A simple habit tracking and diary entry app</p>
            </header>
            <main>
                <section className="habit-section">
                    <div className="habit-text">
                        <h2>Habit Tracking</h2>
                        <p>With Habituate Me, you can easily track your habits and monitor your progress over time. Simply add your habits, and mark them as complete each day.</p>
                        {/* <Link to="/habits" className="button">Get Started</Link> */}
                    </div>
                </section>
                <section className="diary-section">
                    <div className="diary-text">
                        <h2>Diary Entries</h2>
                        <p>Keep track of your thoughts and feelings with Habituate Me's diary entry feature. Write entries, save them, and come back to edit or delete them anytime.</p>
                        {/* <Link to="/diary" className="button">Start Writing</Link> */}
                        <CustomButton
                            displayText="Get started!"
                            className="get-started-button"
                            style={{
                                color: "black",
                                border: "2px solid black",
                                width: "15rem",
                                boxShadow: "5px 5px 0",
                                marginTop: "1.2rem",
                            }}
                            onClick={handleOnClick}
                        // onClick={(e) => verificationLinkHandler(e)}
                        />
                    </div>
                </section>
            </main>
            <footer>
                <p>&copy; 2023 Habituate Me. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default LandingPage;
